import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Ldap } from './../../core/models/ldap';
import { BzgModalService} from 'bz-genome-angular';
import * as _ from 'lodash';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';

@Component({
    selector: 'ldap-attribute-mapping',
    templateUrl: 'ldap-attribute-mapping.component.html',
    styleUrls: ['ldap-attribute-mapping.component.scss']
})
export class LdapAttributeMappingComponent implements OnInit {
    @Input() ldapConfiguration: Ldap;
    @Input() userProperties: any[];

    public isloading = false;
    public claims: Array<any> = [];

    constructor(private _modalService: BzgModalService) { }

    ngOnInit() {
        this.isloading = true;
        let i = 0;

        for (const claim in this.ldapConfiguration.claims) {
            if (this.ldapConfiguration.claims.hasOwnProperty(claim)) {
                let key: any = _.find(this.userProperties, (u) => u.value === claim);
                if(!key){
                    key = { value: '' };
                }

                const value = this.ldapConfiguration.claims[claim];

                this.claims.push({ key, value, position: i, state: false });
                i++;
            }
        }
        this.isloading = false;
    }

    public addMapping() {
        const currentPosition = this.claims.length;
        this.claims.push({ key: { value: '' }, value: '', position: currentPosition, state: false });
    }

    public changeValueMapping(value: any, position: any) {
        const itemMapping = _.find(this.claims, { position });
        itemMapping.key = value;
        this.setFinalClaimsValue();
    }

    public changeTextMapping(value: any, position: number) {
        const itemMapping = _.find(this.claims, (c) => c.position === position);
        itemMapping.value = value;
        this.setFinalClaimsValue();
    }

    public deleteMapping(value: any) {
        const modal = this._modalService.open(DeleteConfirmationComponent, {
          closeOnBackdropClick: false,
          closeOnRouterNavigation: true,
          data: { title: 'LDAP.DELETE_ROW', message: 'LDAP.DELETE_ROW_CONFIRM' } });
        modal.afterClosed().subscribe((result) => {
            if (result === 'delete') {
                const index = this.claims.indexOf(value);
                this.claims.splice(index, 1);
                this.setFinalClaimsValue();
            }
        });
    }

    private setFinalClaimsValue() {
        this.ldapConfiguration.claims = {};

        _.forEach(this.claims, (each) => {
            this.ldapConfiguration.claims[each.key.value] = each.value;
        });
    }
}
